import React from "react";

import { RetroLayout } from "components/retrospective/RetroLayout";
import { RetroCard } from "components/retrospective/RetroCard";
import { Grid } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const PAGE_DATA = {
  title: "ODS - Objetivos de desenvolvimento sustentável",
  subtitle: "Descubra os ODS com os quais sua escola contribui",
  bgGradient: "#35AFE7",
  illustrationSrc: "/static/img/retro2025/sustainableImg.png",
  bgImage: "/static/img/retro2025/sustainable.png",
  pageNum: "5",
};

const useStyles = makeStyles()((theme) => ({
  data: {
    height: "100%",
    width: "100%",
    display: "grid",
    gap: theme.spacing(2),
    paddingTop: theme.spacing(3),
    gridTemplateRows: "repeat(3, 1fr)",
    gridTemplateColumns: "repeat(3, 1fr)",

    // vertical
    flexDirection: "row",

    // horizontal
    "@media (orientation: landscape)": {
      flexDirection: "column",
    },
  },
  imgContainer: {
    flex: 1,
    maxWidth: "100%",
    maxHeight: "100%",
    alignItems: "center",
    justifyContent: "center",
    "& > img": {
      maxWidth: "100%",
      maxHeight: "100%",
    },
  },
}));

export const RetroODS = () => {
  const { classes } = useStyles();
  return (
    <RetroLayout {...PAGE_DATA}>
      <Grid item container className={classes.data}>
        <RetroCard
          mainInfo="ODS 7"
          caption="Energia Limpa e Acessível"
          variant="medium"
          gridColumnHorizontal="span 1"
          gridRowHorizontal="span 3"
          gridColumnVertical="span 3"
          gridRowVertical="span 1"
        >
          <Grid item container className={classes.imgContainer}>
            <img
              src="/static/img/retro2025/07_0.png"
              alt="energia limpa e acessível"
            />
          </Grid>
        </RetroCard>
        <RetroCard
          mainInfo="ODS 11"
          caption="Cidades Sustentáveis"
          variant="medium"
          gridColumnHorizontal="span 1"
          gridRowHorizontal="span 3"
          gridColumnVertical="span 3"
          gridRowVertical="span 1"
        >
          <Grid item container className={classes.imgContainer}>
            <img
              src="/static/img/retro2025/11_0.png"
              alt="cidades e comunidades sustentáveis"
            />
          </Grid>
        </RetroCard>
        <RetroCard
          mainInfo="ODS 13"
          caption="Ação Contra Mudança do Clima"
          variant="medium"
          gridColumnHorizontal="span 1"
          gridRowHorizontal="span 3"
          gridColumnVertical="span 3"
          gridRowVertical="span 1"
        >
          <Grid item container className={classes.imgContainer}>
            <img
              src="/static/img/retro2025/13_0.png"
              alt="ação contra a mudança global do clima"
            />
          </Grid>
        </RetroCard>
      </Grid>
    </RetroLayout>
  );
};
